import React from "react";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import Allocation from "./allocation";
import Recovered from "./recovered";
import FileView from "./fileview";

const API = localStorage.getItem("assethost");
const now = new Date();
const todayY = now.getFullYear();
const todayM = checkZero(now.getMonth() + 1);
const todayD = checkZero(now.getDate());
const date = todayY + '-' + todayM + '-' + todayD;;

function checkZero(num) {
  console.log((num + "").length)
  return (num + "").length === 1 ? "0" + num : num;
}
export default class FlaggedItemsLaw extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      msg: "",
      toastColor: "",
      flaggedAssets: [],
      category: "",
      uniqueIdentifier: "",
      assetStatus: "",
      page: 0,
      size: 10,
      totalPages: 1,
      errors: {},
      categories: [],
      statuses: [],
      startDate: date,
      endDate: date,
      currentAssetId: "",
      currentAssetType: "",
      currentAssetBrand: "",
      currentAssetModel: "",
      currentAssetUniqueIdentier: "",
      flag: null,

      showAllocationModal: false,
      showRecoveredModal: false,
      showReportViewModal: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handlePreviousPage = this.handlePreviousPage.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
    this.fetchFlaggedAssets = this.fetchFlaggedAssets.bind(this);
    this.loadDropdowns = this.loadDropdowns.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${window.location.pathname + window.location.search
        }`;
      return;
    }
    this.loadDropdowns(token);
    this.fetchFlaggedAssets(token);
  }

  fetchFlaggedAssets(token, page = 0) {
    this.setState({ loading: true, msg: "", toastColor: "" });

    let request = {};
    if (this.state.category) {
      request.categoryName = this.state.category;
    }
    if (this.state.uniqueIdentifier) {
      request.uniqueIdentifier = this.state.uniqueIdentifier;
    }
    if (this.state.assetStatus) {
      request.assetStatus = this.state.assetStatus;
    } else {
      request.assetStatus = "FLAGGED";
    }
    if (Number(sessionStorage.getItem("companyProfileId"))) {
      request.companyProfileId = sessionStorage.getItem("companyProfileId");
    }
    if (Number(sessionStorage.getItem("individualProfileId"))) {
      request.individualProfileId = sessionStorage.getItem(
        "individualProfileId"
      );
    }
    request.startDate = this.state.startDate
    request.endDate = this.state.endDate
    axios
      .post(API + "/asset/getallflagged", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        let flaggedAssets = [];
        let totalPages = 1;
        if (Array.isArray(response.data)) {
          flaggedAssets = response.data;
        } else if (
          response.data &&
          response.data.content &&
          Array.isArray(response.data.content)
        ) {
          flaggedAssets = response.data.content;
          totalPages = response.data.totalPages || 1;
        }
        this.setState({
          flaggedAssets,
          page,
          totalPages,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${window.location.pathname + window.location.search
            }`;
        }
        this.setState({
          flaggedAssets: [],
          totalPages: 1,
          loading: false,
          msg:
            error?.response?.data?.message || "Failed to load flagged assets.",
          toastColor: "danger",
        });
      });
  }

  loadDropdowns(token) {
    axios
      .get(API + "/asset/getassetflaggedsearchdropdownlist", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const data = response.data || {};
        this.setState({
          categories: data.categories || [],
          statuses: data.assetStatuss || [],
        });
      })
      .catch((error) => {
        // Don't show error for dropdown loading failure, just continue
        console.log("Failed to load dropdowns:", error);
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSelect(name, value) {
    this.setState({ [name]: value }, this.validate);
  }

  handleSearch(e) {
    e.preventDefault();
    const token = sessionStorage.getItem("token");
    this.fetchFlaggedAssets(token, 0);
  }

  handlePreviousPage() {
    if (this.state.page > 0) {
      const token = sessionStorage.getItem("token");
      this.fetchFlaggedAssets(token, this.state.page - 1);
    }
  }

  handleNextPage() {
    if (this.state.page + 1 < this.state.totalPages) {
      const token = sessionStorage.getItem("token");
      this.fetchFlaggedAssets(token, this.state.page + 1);
    }
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    const rowButtons = (asset) => {
      const allocationButton =
        asset?.primaryStatus?.toUpperCase() === "FLAGGED" && asset?.officialReport?.toUpperCase() === "YES" ? (
          <a
            key={`allocation-action-clickable`}
            className="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover cursor-pointer"
            onClick={() =>
              this.setState({
                showAllocationModal: true,
                currentAssetId: asset.assetId,
                flag: asset,
              })
            }
          >
            Allocation
          </a>
        ) : null;

      const recoveredButton =
        (asset?.primaryStatus?.toUpperCase() === "LOST" || asset?.primaryStatus?.toUpperCase() === "STOLEN") ? (
          <a
            key={`recover-action-clickable`}
            className="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover cursor-pointer"
            onClick={() =>
              this.setState({
                showRecoveredModal: true,
                currentAssetId: asset.assetId,
                currentAssetType: asset.categoryName,
                currentAssetModel: asset.subcategoryName,
                currentAssetBrand: asset.brand,
                currentAssetUniqueIdentier: asset.uniqueIdentifier,
              })
            }
          >
            Recovered
          </a>
        ) : null;
      const fileViewButton =
        asset?.officialReport?.toUpperCase() === "YES" ?
          <a
            key={`report-view`}
            className="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover cursor-pointer"
            onClick={() =>
              this.setState({
                showReportViewModal: true,
                currentflagId: asset.flagId
              })
            }
          >
            Police Report View
          </a> : null
      return (
        <div className="d-flex gap-1 flex-wrap w-44">
          {allocationButton}
          {recoveredButton}
          {fileViewButton}
        </div>
      );
    };

    return (
      <div className="min-vh-100 d-flex justify-content-between bg-white">
        <Sidebar />
        <div className="min-vh-100 flex-grow-1 d-flex flex-column">
          <Banner title="Flagged Items" />
          {divMsg}
          <div className="w-100 flex-grow-1 px-5 d-flex flex-column align-items-center justify-content-start">
            <form
              className="row g-2 w-100 mb-2"
              autoComplete="off"
              onSubmit={this.handleSearch}
            >
              <div className="col-4">
                <div className="input-group">
                  <label className="input-group-text !w-fit">Category</label>
                  <select
                    name="category"
                    className="form-control"
                    value={s.category}
                    onChange={this.handleChange}
                  >
                    <option value="">Select</option>
                    {s.categories.map((cat, index) => (
                      <option key={`category-${index}`} value={cat}>
                        {cat}
                      </option>
                    ))}
                  </select>
                  {s.errors.category && (
                    <span className="input-group-error">{s.errors.category}</span>
                  )}
                </div>
              </div>
              <div className="col-4">
                <div className="input-group">
                  <label className="input-group-text !w-fit">
                    Unique Identifier
                  </label>
                  <input
                    name="uniqueIdentifier"
                    className="form-control"
                    type="text"
                    value={s.uniqueIdentifier}
                    onChange={this.handleChange}
                  />
                  {s.errors.uniqueIdentifier && (
                    <span className="input-group-error">
                      {s.errors.uniqueIdentifier}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-4">
                <div className="input-group">
                  <label className="input-group-text !w-fit">
                    Start Date
                  </label>
                  <input
                    name="startDate"
                    className="form-control"
                    type="date"
                    value={s.startDate}
                    onChange={this.handleChange}
                  />
                  {s.errors.startDate && (
                    <span className="input-group-error">
                      {s.errors.startDate}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-4">
                <div className="input-group">
                  <label className="input-group-text !w-fit">
                    Unique Identifier
                  </label>
                  <input
                    name="endDate"
                    className="form-control"
                    type="date"
                    value={s.endDate}
                    onChange={this.handleChange}
                  />
                  {s.errors.endDate && (
                    <span className="input-group-error">
                      {s.errors.endDate}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-3">
                <div className="input-group">
                  <label className="input-group-text !w-fit">Status</label>
                  <select
                    name="status"
                    className="form-control"
                    value={s.assetStatus}
                    onChange={(e) =>
                      this.handleSelect("assetStatus", e ? e.target.value : "")
                    }
                  >
                    <option value="">Select</option>
                    {s.statuses.map((stat, index) => (
                      <option key={`asset-status-${index}`} value={stat}>
                        {stat}
                      </option>
                    ))}
                  </select>
                  {s.errors.status && (
                    <span className="input-group-error">{s.errors.status}</span>
                  )}
                </div>
              </div>
              <button
                type="button"
                className="btn btn-primary col-1"
                onClick={this.handleSearch}
              >
                Search
              </button>
            </form>

            <div className="w-100 overflow-auto border rounded">
              <table className="table table-striped table-hover rounded">
                <thead className="table-primary">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                      Category
                    </th>
                    <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                      Brand
                    </th>
                    <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                      Unique Identifier
                    </th>
                    <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                      Status
                    </th>
                    <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="">
                  {s.flaggedAssets.map((asset, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-dark">
                        {asset.categoryName || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-dark">
                        {asset.subcategoryName || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-dark">
                        {asset.uniqueIdentifier || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-dark">
                        {asset.primaryStatus || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm fw-medium">
                        {rowButtons(asset)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {s.flaggedAssets.length === 0 && (
                <div className="text-muted text-center py-4">
                  No flagged assets found.
                </div>
              )}
            </div>

            {s.totalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
                <button
                  className="btn btn-outline"
                  disabled={s.page === 0}
                  onClick={this.handlePreviousPage}
                >
                  Previous
                </button>
                <span>
                  Page {s.page + 1} of {s.totalPages}
                </span>
                <button
                  className="btn btn-outline"
                  disabled={s.page + 1 >= s.totalPages}
                  onClick={this.handleNextPage}
                >
                  Next
                </button>
              </div>
            )}
          </div>

        </div>
        {s.showRecoveredModal && (
          <Recovered
            key={`recover-asset-${s.currentAssetId}`}
            closeAction={() => this.setState({ showRecoveredModal: false })}
            assetId={s.currentAssetId}
            assetType={s.currentAssetType}
            assetBrand={s.currentAssetBrand}
            assetModel={s.currentAssetModel}
            assetUniqueIdentier={s.currentAssetUniqueIdentier}
            onSuccess={() => {
              this.setState({ showRecoveredModal: false });
              this.fetchFlaggedAssets(
                sessionStorage.getItem("token"),
                this.state.page
              );
            }}
          />
        )}
        {s.showAllocationModal && (
          <Allocation
            key={`asset-flag-append-${s.currentAssetId}`}
            closeAction={() => this.setState({ showAllocationModal: false })}
            assetId={s.currentAssetId}
            flag={s.flag}
            onSuccess={() => {
              this.setState({ showAllocationModal: false });
              this.fetchFlaggedAssets(
                sessionStorage.getItem("token"),
                this.state.page
              );
            }}
          />
        )}

        {s.showReportViewModal && (
          <FileView
            key={`asset-flag-append-${s.currentflagId}`}
            closeAction={() => this.setState({ showReportViewModal: false })}
            flagId={s.currentflagId}
            onSuccess={() => {
              this.setState({ showAllocationModal: false });
              this.fetchFlaggedAssets(
                sessionStorage.getItem("token"),
                this.state.page
              );
            }}
          />
        )}
      </div>
    );
  }
}
